import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { useGetSearchPaginatedProfileQuery } from '../apis/ShopProfileApi';
import { Pagination } from '@mui/material';
import { addProduct } from '../common/slices/searchedProductSlice';
import TextSliderAmazon from './TextSliderAmazon';

const SearchLoader = () => {
    const searchString = useSelector((state) => state.searchString.searchString);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();

    const { 
        data: searchResults,
        error, 
        isLoading,
        isFetching 
    } = useGetSearchPaginatedProfileQuery({ 
        shopName: searchString,
        page: page - 1,
        size: 6
    });
    const handleVendorClick = () => {
        // Dispatch the action with the vendor's details
        dispatch(addProduct(searchResults?.profile));
       // console.log("recentSearched searchResults?.profile",searchResults?.profile);

    };
    const SampleNextArrow = ({ onClick }) => (
        <button
            type="button" 
            onClick={onClick}
            className="slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1"
        >
            <i className="ph ph-caret-right" />
        </button>
    );

    const SamplePrevArrow = ({ onClick }) => (
        <button
            type="button"
            onClick={onClick}
            className="slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1"
        >
            <i className="ph ph-caret-left" />
        </button>
    );

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: { slidesToShow: 6 }
            },
            {
                breakpoint: 1399,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 575,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 424,
                settings: { slidesToShow: 1 }
            },
        ],
    };

    if (isLoading) return (
        <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress /> 
        </div>
    );    if (error) return <div>Error loading vendors: {error.message}</div>;

    return (
        <>
        {!searchResults?.profile?.length && !isFetching ? (
            <di></di>
 ) : (

    <section className="organic-food py-30">
    <div className="container container-lg">
        <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
                <h5 className="mb-0">Found vendors</h5>
                      
           </div>
        </div>
        {isFetching && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress size={24} />
                    </div>
                )} 
        {!searchResults?.profile?.length && !isFetching && (
            <div className="text-center py-12">No vendors found matching your search</div>
        )}

        {searchResults?.profile?.length > 0 && (
            <>
                <div className="organic-food__slider arrow-style-two">
                    <Slider {...settings}>
                        {searchResults.profile.map((vendor) => (
                            <div key={vendor.id}>
                                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                    <NavLink
                                        to={`/vendor/${vendor.userId}`}
                                        className="product-card__thumb flex-center"
                                        onClick={handleVendorClick} // Add onClick handler

                                    >
                                        <img 
                                            src={vendor.imageLogoUrl} 
                                            alt={vendor.shopName} 
                                            className="rounded-circle"
                                            style={{
                                                width: '120px',
                                                height: '120px',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </NavLink>
                                    <div className="product-card__content mt-12">
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8 text-center">
                                            <NavLink 
                                                to={`/vendor/${vendor.userId}`} 
                                                className="NavLink"
                                                onClick={handleVendorClick} // Add onClick handler

                                            >
                                                {vendor.shopName}
                                            </NavLink>
                                        </h6>
                                        <div className="flex-align gap-4 justify-center">
                                            <span className="text-main-600 text-md d-flex">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-gray-500 text-xs">
                                                {vendor.userName}
                                            </span>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Pagination */}
                <div className="pagination-container flex-center mt-4">
                    <Pagination
                        count={searchResults.totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                    />
                </div>
            </>
        )}
    </div>
</section>)}
        </>
    );
};

export default SearchLoader;
